import { render } from "./ServiceInputForm.vue?vue&type=template&id=556e955b&scoped=true"
import script from "./ServiceInputForm.vue?vue&type=script&lang=js"
export * from "./ServiceInputForm.vue?vue&type=script&lang=js"

import "./ServiceInputForm.vue?vue&type=style&index=0&id=556e955b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-556e955b"]])

export default __exports__